export default function Footer() {
  return (
    <footer className="w-full border-t border-background-200 bg-secondary-100/50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-12">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-water-flash-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">朝阳吃瓜</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              聚合朝阳吃瓜热门话题、朝阳吃瓜榜与头条热议的内容平台，理性围观，跟上节奏，和全网同频吃瓜。
            </p>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold text-foreground-900">站内导航</h4>
            <ul className="space-y-2.5 text-sm">
              {[
                ['#bang', '朝阳吃瓜榜'],
                ['#rehua', '热门话题'],
                ['#pindao', '吃瓜频道'],
                ['#guanyu', '关于我们'],
              ].map(([href, label]) => (
                <li key={href}>
                  <a href={href} className="text-foreground-600 transition hover:text-primary-600">{label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold text-foreground-900">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2"><i className="ri-mail-line text-primary-600"></i> hi@zhaoyangchigua.cn</li>
              <li className="flex items-center gap-2"><i className="ri-time-line text-primary-600"></i> 工作日 09:00 – 21:00</li>
              <li className="flex items-center gap-2"><i className="ri-map-pin-line text-primary-600"></i> 立足北京朝阳</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 朝阳吃瓜 · 仅聚合公开讨论信息，倡导理性吃瓜
          </p>
          <a
            href="#top"
            className="flex items-center gap-1.5 rounded-full border border-background-300 bg-background-50 px-4 py-2 text-xs text-foreground-700 transition hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-arrow-up-line"></i> 回到顶部
          </a>
        </div>
      </div>
    </footer>
  );
}